/**
 * @generated SignedSource<<647022319478e9322b4f480a74458504>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type accountBillingInfoAddressFragment$data = {
  readonly billingAddressLineOne: string | null;
  readonly billingAddressLineTwo: string | null;
  readonly billingCity: string | null;
  readonly billingState: string | null;
  readonly billingCountryId: string | null;
  readonly billingZip: string | null;
  readonly billingCountry: {
    readonly " $fragmentSpreads": FragmentRefs<"countryFragment">;
  } | null;
  readonly " $fragmentType": "accountBillingInfoAddressFragment";
};
export type accountBillingInfoAddressFragment$key = {
  readonly " $data"?: accountBillingInfoAddressFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"accountBillingInfoAddressFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "accountBillingInfoAddressFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "billingAddressLineOne",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "billingAddressLineTwo",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "billingCity",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "billingState",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "billingCountryId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "billingZip",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Country",
      "kind": "LinkedField",
      "name": "billingCountry",
      "plural": false,
      "selections": [
        {
          "kind": "InlineDataFragmentSpread",
          "name": "countryFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isoCodeTwo",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isoCodeThree",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "continentName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "currency",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "currencySymbol",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AccountBillingInfo",
  "abstractKey": null
};

(node as any).hash = "1bba6a081546e59c3f2bc5f8327ad191";

export default node;
